import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import Footer from "./Footer";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";

const ContactSection = () => {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col min-h-screen ">
      {/* Main Content */}
      <div className="flex-grow bg-white pt-12 pb-12 max-w-6xl items-center mx-auto">
        <section className="container mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Left Side - Contact Info */}
            <div>
              <h2 className="text-3xl font-bold text-red-700">
                {translations[language].GetInTouch}{" "}
                {/* <span className="text-red-700">
                  {translations[language].Touch}
                </span> */}
              </h2>
              <div className="mt-6 space-y-6">
                {/* Visit Us */}
                <div className="flex items-center p-6 bg-white shadow-lg rounded-lg">
                  <MapPin className="text-red-700 w-10 h-10 mr-4" />
                  <div>
                    <h3 className="text-lg text-gray-900 font-semibold">
                      {translations[language].visitUs}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {translations[language].GoldenGateTower}
                      <br />
                      {translations[language].UpperPazuntaung} <br />
                      {translations[language].Mingalartaungnyunt}
                    </p>
                  </div>
                </div>

                {/* Call Us */}
                <div className="flex items-center p-6 bg-white shadow-lg rounded-lg">
                  <Phone className="text-red-700 w-10 h-10 mr-4" />
                  <div>
                    <h3 className="text-lg text-gray-900 font-semibold">
                      {translations[language].callUs}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {translations[language].Ph1} <br />{" "}
                      {translations[language].Ph2}
                    </p>
                  </div>
                </div>

                {/* Email Us */}
                <div className="flex items-center p-6 bg-white shadow-lg rounded-lg">
                  <Mail className="text-red-700 w-10 h-10 mr-4" />
                  <div>
                    <h3 className="text-lg text-gray-900 font-semibold">
                      {translations[language].emailUs}
                    </h3>
                    <p className="text-gray-600 text-sm">contact@mcbwi.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-red-700">
                {translations[language].SendUsAnEnquiry}{" "}
                {/* <span className="text-red-700">
                  {translations[language].AnEnquiry}
                </span> */}
              </h2>

              <form className="mt-6 space-y-4">
                <input
                  type="text"
                  placeholder={translations[language].FullName}
                  className="w-full p-3 border border-gray-300 rounded-md text-black"
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="email"
                    placeholder={translations[language].email}
                    className="w-full p-3 border border-gray-300 rounded-md text-black"
                  />
                  <input
                    type="text"
                    placeholder={translations[language].contactNo}
                    className="w-full p-3 border border-gray-300 rounded-md text-black"
                  />
                </div>
                <input
                  type="text"
                  placeholder={translations[language].company}
                  className="w-full p-3 border border-gray-300 rounded-md text-black"
                />
                <textarea
                  rows="4"
                  placeholder={translations[language].message}
                  className="w-full p-3 border border-gray-300 rounded-md text-black"
                ></textarea>
                <button
                  type="submit"
                  className="w-full bg-red-600 text-white font-semibold py-3 rounded-md hover:bg-red-700 transition"
                >
                  {translations[language].sendMessage}
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Sticks at the Bottom */}
      <Footer />
    </div>
  );
};

export default ContactSection;
